import React from 'react';
import { Card } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
// import img from "../../assets/images"

const StatCard = (props) => {
    const navigate = useNavigate();
    const { img_url, title, counter, text, text_color, units, unit, icon } = props;

    const getTitleWithUnit = (title) => {
        if (title == 'Distance') {
            return `${title} (${units?.distanceUnit ? units?.distanceUnit : ''})`;
        } else if (title == 'GHG Emissions') {
            return `${title} (${units?.ghgUnit ? units?.ghgUnit : ''})`;
        } else {
            return title;
        }
    };

    const getValueWithUnit = (title, value) => {
        const formatGHGValue = (value) => {
            if (value >= 1e6) {
                return `${(value / 1e6).toFixed(2)} Mt`; // Megatons
            } else if (value >= 1e3) {
                return `${(value / 1e3).toFixed(2)} kt`; // Kilotons
            } else {
                return `${value.toFixed(2)} t`; // Tons
            }
        };

        if (title === 'Distance' || title === 'Total Distance Travelled') return `${value} ${value ? units?.distanceUnit || 'km' : ''}`;
        if (title === 'Distance') return `${value} ${value ? units?.distanceUnit || '' : null}`;
        if (title === 'GHG Emissions Saved') return `${value} ${unit ? unit : 'kg'}`;
        if (title === 'GHG Saved') return value ? formatGHGValue(value) : '0 t';
        if (title === 'Lifetime Transit Reward Points') return value ? Math.floor(value) : '0'; // Ensure integer value
        if (title === 'Next Reward Level') return value ? Math.floor(value) : '0'; // Ensure integer value
        if (title === 'Avg Trip Length') return `${value} ${units?.distanceUnit || 'km'}`;
        return value;
    };

    return (
        <>
            <Card className="card-wrapper">
                <Card.Body className="p-2">
                    <div className="d-flex justify-content-start flex-column">
                        <div className="card-content-wrapper">
                            {icon ? icon : <img className="img-fluid" src={img_url} alt="" style={{ maxWidth: 70 }} />}
                            <div className="stat-card-header">
                                <div className="card-heading mt-1">{title}</div>
                                <div className="card-count mb-1">
                                    {title === 'Tier' && (counter === '' || counter === null) ? 'N/A' : getValueWithUnit(title, counter)}
                                </div>
                            </div>
                        </div>
                        <div className="tier-view-btn">
                            {title === 'Tier' && (
                                <button className="btn btn-icon" onClick={() => navigate('/demographics/rewards')}>
                                    <FaEye />
                                </button>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default StatCard;
